import Container1 from "@p-v/packages/Decorate/Container1/index.vue"
import Container2 from "@p-v/packages/Decorate/Container2/index.vue"
import Container3 from "@p-v/packages/Decorate/Container3/index.vue"
import Container4 from "@p-v/packages/Decorate/Container4/index.vue"
import Container5 from "@p-v/packages/Decorate/Container5/index.vue"
import Container6 from "@p-v/packages/Decorate/Container6/index.vue"
import PftArticle from "@p-v/packages/Decorate/Article/index.vue"
import PftNotice from "@p-v/packages/Decorate/Notice/index.vue"
import NumberTitlte from "@p-v/packages/Decorate/NumberTitle/index.vue"
import NumberTitle from "@p-v/packages/Decorate/NumberTitle/index.vue"
import HtmlElement from "@p-v/packages/HtmlElement.vue"

import ScanCircle from "@p-v/packages/Animation/ScanCircle.vue"
import ScanCircle2 from "@p-v/packages/Animation/ScanCircle2.vue"

import PftTable from "@p-v/packages/Table/index.vue"
import PftProgress from "@p-v/packages/Table/components/progress.vue"
import Tip from "@p-v/packages/Decorate/Tip/index.vue"
import PftDataText from "@p-v/packages/DataText.vue"
import DataText2 from "@p-v/packages/DataText2/index.vue"
import DataText3 from "@p-v/packages/DataText3/index.vue"
import DataRow from "@p-v/packages/DataRow/index.vue"
import List1 from "@p-v/packages/List/List1.vue"
import List2 from "@p-v/packages/List/List2.vue"
import List3 from "@p-v/packages/List/List3.vue"
import DataCompare from "@p-v/packages/DataCompare/index.vue"
import DataItem from "@p-v/packages/DataItem.vue"
import Clock from "@p-v/packages/Clock/index.vue"
import DataFlipper from "@p-v/packages/DataFlipper/index.vue"
import RaiseOrFall from "@p-v/packages/RaiseOrFall.vue"
import PftDebug from "@p-v/packages/Debug.vue"

import DoubleAxisLineChart from "@p-v/packages/Charts/DoubleAxisLineChart/index.vue"
import XAxisLineChart from "@p-v/packages/Charts/xAxisLineChart/index.vue"
import Gauge from "@p-v/packages/Charts/Gauge/index.vue"
import PieDoughuntChart from "@p-v/packages/Charts/PieDoughuntChart/index.vue"
import StackedBarChart from "@p-v/packages/Charts/StackedBarChart/index.vue"
import LineWithBarChart from "@p-v/packages/Charts/LineWithBarChart/index.vue"
import HorizanBarChart from "@p-v/packages/Charts/HorizanBarChart/index.vue"
import VerticalBarChart from "@p-v/packages/Charts/VerticalBarChart/index.vue"
import PercentageChart from "@p-v/packages/Charts/PercentageChart/index.vue"
import CompareChart from "@p-v/packages/Charts/CompareChart/index.vue"

import PftMapChart from "@p-v/packages/Map/BaiduMapChart/index.vue"
import MapGround from "@p-v/packages/Map/BaiduMapChart/ground.vue"
import MapMaker from "@p-v/packages/Map/BaiduMapChart/marker.vue"
import MapPolygon from "@p-v/packages/Map/BaiduMapChart/polygon.vue"
import MapCustomMarker from "@p-v/packages/Map/BaiduMapChart/customMarker.vue"
import PftMapMaker from "@p-v/packages/Map/BaiduMapChart/pftMarker.vue"
import MapInfoMaker from "@p-v/packages/Map/BaiduMapChart/infoMark.vue"
import MapZoom from "@p-v/packages/Map/BaiduMapChart/zoom.vue"
import MapPath from "@p-v/packages/Map/BaiduMapChart/path.vue"

import PftAMap from "@p-v/packages/Map/AMapChart/index.vue"
import AMapMarker from "@p-v/packages/Map/AMapChart/marker.vue"
import AMapInfoWindow from "@p-v/packages/Map/AMapChart/infoWindow.vue"

import PftGeoMap from "@p-v/packages/Map/GeoMap/index.vue"
import MapBlock from "@p-v/packages/Map/GeoMap/map.vue"
import MapLines from "@p-v/packages/Map/common/lines.vue"
import MapScatter from "@p-v/packages/Map/common/scatter.vue"
import MarkSimpleInfo from "@p-v/packages/Map/BaiduMapChart/infoTemplate/simpleInfo.vue"

import PftWeather from "@p-v/packages/Functional/Weather/index.vue"
import DateRange from "@p-v/packages/Functional/DateRange/index.vue"
import ExportManager from "@p-v/packages/Functional/ExportManager/index.vue"
import ExportBtn from "@p-v/packages/Functional/ExportManager/btn.vue"

import PftWordCloud from "@p-v/packages/Charts/WordCloud/index.vue"
import PftToolTip from "@p-v/packages/FeedBack/toolTip.vue"
import PftCarousel from "@p-v/packages/Functional/Common/carousel.vue"

import PftMenuTriger from "@p-v/packages/Functional/Menu/Triger.vue"
import PftMenuPannel from "@p-v/packages/Functional/Menu/Pannel.vue"

import PftFullScreen from "@p-v/packages/Functional/FullScreen.vue"
import PftDateView from "@p-v/packages/Functional/DateView/index.vue"

import DecoratorPic from "@p-v/packages/Decorate/DecoratorPic.vue"
import DecoratorText from "@p-v/packages/Decorate/DecoratorText.vue"
import Group from "@p-v/packages/Decorate/Group.vue"
import DataCard from "@p-v/packages/DataCard.vue"
import TabSwitch from "@p-v/packages/TabSwitch.vue"

import EarlyWarning from "./packages/Decorate/EarlyWarning/index.vue"

import DynamicRender from "@p-v/packages/DynamicRender.vue"

import ProductHeader from "@p-v/packages/Functional/ProductRow/header.vue"
import ProductRow from "@p-v/packages/Functional/ProductRow/index.vue"

import TrendPercent from "@p-v/packages/Functional/TrendPercent/index.vue"

import PftIterator from "@p-v/packages/Functional/Common/Iterator.vue"

import PftDatePicker from "@p-v/packages/Date/picker.vue"
import PftDayPicker from "@p-v/packages/Date/day.vue"
import PftDateComparePicker from "@p-v/packages/Date/compare.vue"

import PftLegend from "@p-v/packages/Decorate/Legend.vue"

import Loading from "@p-v/packages/Loading.vue"

import PftMobileDatePicker from "@p-v/mobilePackages/DatePicker/index.vue"
import PftMobileHeader from "@p-v/mobilePackages/Header/index.vue"

import * as utils from "@p-v/utils/index"

import "@p-v/asset/style.css"
import "@p-v/asset/fonts/iconfont.css"
// 2. 引入组件样式
import "vant/lib/index.css"

import type { App } from "vue"

export const componentList = {
  DoubleAxisLineChart,
  Container1,
  Container2,
  Container3,
  PftTable,
  PftDataText,
  Tip,
  Gauge,
  PieDoughuntChart,
  StackedBarChart,
  List1,
  List2,
  List3,
  Loading,
  Container4,
  DataText2,
  Container5,
  DataText3,
  DataCompare,
  Container6,
  DataItem,
  LineWithBarChart,
  HorizanBarChart,
  VerticalBarChart,
  Clock,
  ScanCircle,
  ScanCircle2,
  PftWeather,
  DateRange,
  XAxisLineChart,
  PercentageChart,
  DataFlipper,
  PftMapChart,
  MapGround,
  MapMaker,
  MapScatter,
  MapBlock,
  PftMapMaker,
  MapLines,
  PftGeoMap,
  MapInfoMaker,
  MarkSimpleInfo,
  PftArticle,
  PftNotice,
  ExportManager,
  DataRow,
  RaiseOrFall,
  MapPath,
  PftProgress,
  PftWordCloud,
  MapPolygon,
  MapCustomMarker,
  MapZoom,
  PftToolTip,
  PftCarousel,
  PftMenuTriger,
  PftMenuPannel,
  PftFullScreen,
  PftDateView,
  DecoratorPic,
  DynamicRender,
  DecoratorText,
  Group,
  DataCard,
  PftDayPicker,
  PftDatePicker,
  TabSwitch,
  ProductRow,
  TrendPercent,
  PftIterator,
  ProductHeader,
  PftDateComparePicker,
  CompareChart,
  PftLegend,
  PftMobileDatePicker,
  PftMobileHeader,
  HtmlElement,
  ExportBtn,
  PftDebug,
  NumberTitlte,
  NumberTitle,
  EarlyWarning,
}
// 所有组件列表
const components = Object.values(componentList)

// 定义 install 方法
const install = (app: App): void => {
  // 遍历注册所有组件
  /*
    component.__name ts报错
    Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    Type 'undefined' is not assignable to type 'string'.ts(2345)
    解决方式一：使用// @ts-ignore
    解决方式二：使用类型断言 尖括号语法(component.__name) 或 as语法(component.__name as string)
  */
  components.forEach(component => app.component(component.__name as string, component))
}

const VueAmazingUI = {
  install,
}

export default VueAmazingUI

export function getComponentList() {
  return components
}

export {
  DoubleAxisLineChart,
  Container1,
  Container2,
  Container3,
  PftTable,
  PftDataText,
  Tip,
  Gauge,
  PieDoughuntChart,
  StackedBarChart,
  List1,
  List2,
  List3,
  Loading,
  Container4,
  DataText2,
  Container5,
  DataText3,
  DataCompare,
  Container6,
  DataItem,
  LineWithBarChart,
  HorizanBarChart,
  VerticalBarChart,
  Clock,
  ScanCircle,
  ScanCircle2,
  PftWeather,
  utils,
  DateRange,
  XAxisLineChart,
  PercentageChart,
  DataFlipper,
  PftMapChart,
  MapGround,
  MapMaker,
  MapScatter,
  MapBlock,
  PftMapMaker,
  MapLines,
  PftGeoMap,
  MapInfoMaker,
  MarkSimpleInfo,
  PftArticle,
  PftNotice,
  ExportManager,
  DataRow,
  RaiseOrFall,
  MapPath,
  PftProgress,
  PftWordCloud,
  MapPolygon,
  MapCustomMarker,
  MapZoom,
  PftToolTip,
  PftCarousel,
  PftMenuTriger,
  PftMenuPannel,
  PftFullScreen,
  PftDateView,
  DecoratorPic,
  DynamicRender,
  DecoratorText,
  Group,
  DataCard,
  PftDatePicker,
  PftDayPicker,
  TabSwitch,
  ProductRow,
  TrendPercent,
  PftIterator,
  ProductHeader,
  PftDateComparePicker,
  CompareChart,
  PftLegend,
  PftMobileDatePicker,
  PftMobileHeader,
  HtmlElement,
  ExportBtn,
  PftDebug,
  NumberTitlte,
  NumberTitle,
  EarlyWarning,

  // 高德地图组件
  PftAMap,
  AMapMarker,
  AMapInfoWindow,
}
